import React, { ReactNode } from 'react';

import './sound-waves-background-zoomed.css';

interface Props {
    children?: ReactNode;
}

export const SoundWavesBackgroundZoomed = ({
    children,
}: Props): JSX.Element => (
    <div className="sound-waves-background-zoomed bg-no-repeat">{children}</div>
);
